<template>
  <vue-draggable-resizable
    :w="item.width"
    :h="item.height"
    :x="item.x"
    :y="item.y"
    :style="{
      border: active
        ? '1px dashed #cccccc'
        : bordersActive
        ? '1px dashed #cccccc'
        : 'none',
      zIndex: active ? 99999 : item.index,
    }"
    parent=".compo"
    :debug="true"
    :min-width="item.minWidth"
    :min-height="item.minHeight"
    :is-conflict-check="false"
    :snap="true"
    :lock-aspect-ratio="item.lockAspectRatio"
    :draggable="draggable"
    :resizable="resizable"
    @resizing="onResize"
    @refLineParams="getRefLineParams"
    @dragging="onDrag"
    @activated="setSelected"
    @deactivated="setUnselected"
    :active="active"
  >
    <div
      class="flex absolute inset-0 justify-center items-center hover:block opacity-0 hover:opacity-100"
      v-if="!item.type"
      @mouseover="active = true"
      @mouseleave="active = false"
    >
      <button class="btn" @click="item.type = 'image'">
        <font-awesome-icon icon="image"></font-awesome-icon>
      </button>
      <button class="btn" @click="item.type = 'html'">
        <font-awesome-icon icon="font"></font-awesome-icon>
      </button>
    </div>
    <!-- <cropper
      classname="cropper"
      src="https://res.cloudinary.com/managerfashion/image/upload/f_auto/v1494644841/c1581/t57/book/lux-3d-text-effect3_lviyan.png"
      :stencilProps="{
        aspectRatio: 10 / 12,
      }"
      @change="change"
    ></cropper>-->
    <div
      class="absolute inset-0 z-50"
      @click="active = true"
      v-if="draggable"
    ></div>
    <div :id="label"></div>
    <croppa
      v-if="item.type == 'image'"
      :width="item.width"
      :height="item.height"
      :show-remove-button="false"
      v-model="crop"
      :zoom-speed="10"
      :file-size-limit="0"
      :prevent-white-space="false"
      canvas-color="white"
      :accept="'image/*'"
      @pointermove="setSelected"
      @pointerleave="setUnselected"
      @dblclick="findNewImage"
      :quality="6"
      class="absolute inset-0 overflow-hidden"
    ></croppa>
  </vue-draggable-resizable>
</template>

<script>
export default {
  props: ['item', 'label', 'draggable', 'resizable', 'bordersActive'],
  data() {
    return {
      active: false,
      image: null,
      crop: null,
    }
  },
  watch: {
    'item.type': function (type) {
      this.$nextTick(() => {
        if (type == 'image') {
          this.crop.chooseFile()
        }
        if (type == 'html') {
          this.initSummernote()
        }
      })
    },
  },
  methods: {
    initSummernote() {
      $(`#${this.label}`).summernote({
        height: this.item.height - 2,
        toolbar: false,
        followingToolbar: false,
      })
    },
    findNewImage() {
      this.crop.chooseFile()
    },
    setSelected() {
      this.active = true
      this.$emit('setSelected', this.label)
    },
    setUnselected() {
      this.active = false
      this.$emit('setSelected', '')
    },
    getRefLineParams(params) {
      this.$emit('refLineParams', params)
    },
    onResize: function (x, y, width, height) {
      this.item.x = x
      this.item.y = y
      this.item.width = width
      this.item.height = height
    },
    onDrag: function (x, y) {
      this.item.x = x
      this.item.y = y
    },
  },
}
</script>

<style></style>
